type AnalyticsPayload = Record<string, string | number | boolean | null | undefined>;

export async function trackEvent(name: string, payload: AnalyticsPayload = {}) {
  try {
    const { hasWebsiteConsent } = await import("./consent");
    if (!hasWebsiteConsent("analytics")) return;

    const cleanPayload = Object.fromEntries(
      Object.entries(payload).filter(([, value]) => value !== undefined && value !== null)
    );

    const [{ getFirebaseAnalytics }, { logEvent }] = await Promise.all([
      import("./firebase"),
      import("firebase/analytics")
    ]);
    const analytics = await getFirebaseAnalytics();
    if (analytics) {
      logEvent(analytics, name, cleanPayload);
    }
  } catch {
    // Analytics must never block acquisition or onboarding flows.
  }
}
